<soft-page>
  <soft-page-header>
    <div class="w-full flex items-center justify-between">
      <soft-icon
        name="fa-regular fa-magnifying-glass"
        class="text-light mr-2"
      ></soft-icon>
      <soft-input
        #input
        (valueChange)="searchText$.next(input?.value ?? '')"
        [placeholder]="'#WORKSHOP.TASK_OUTLINE.SEARCH.PLACEHOLDER' | translate"
      ></soft-input>
      <div class="flex justify-end ml-8">
        <soft-toggle-switch
          [value]="vertreterFilterActive$ | async"
          (valueChange)="vertreterFilterService.vertreterFilterActive$.next($event)"
        ></soft-toggle-switch>
        <p class="text-xs text-light ml-2">Nur eigene Anzeigen</p>
      </div>
    </div>
  </soft-page-header>

  @if (filteredAuftraege$ | async; as auftraege) {
    <section class="mt-4 pb-3 mb-3">
      @if (auftraege?.length || 0 > 0 || (loading$ | async) === false) {
        <div class="card-stack mt-4 mb-3">
          @for (auftrag of auftraege; track auftrag.id) {
            <soft-auftrag-card
              [auftrag]="auftrag"
              (click)="navigateTo(auftrag)"
            ></soft-auftrag-card>
          }
        </div>
      }
    </section>
  }
  @if (loading$ | async) {
    <section>
      <div class="flex flex-row justify-center items-center center-h h-1/2 color-light">
        <soft-loading-spinner class="spin"></soft-loading-spinner>
        <p class="pl-2">Aufträge werden geladen...</p>
      </div>
    </section>
  } @else {
    @if ((loaded$ | async) && (filteredAuftraege$ | async)?.length === 0) {
      <div class="flex flex-row justify-center items-center center-h h-1/2 color-light">
        {{ '#WORKSHOP.COMPONENTS.OVERVIEW.NO_DATA' | translate }}
      </div>
    }
  }
</soft-page>
